<template>
  <div>
    <div class="columns">
      <div class="column">
        Presenza cooler
        <div class="field">
          <b-switch v-model="currentCard.valutations.cooler"></b-switch>
        </div>
      </div>
      <div class="column">
        <b-field label="Modello Cooler">
          <b-input
            v-model.trim="currentCard.valutations.coolerDescription"
            v_uppercase="currentCard.valutations.coolerDescription"
            :disabled="!currentCard.valutations.cooler"
          ></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Grossista">
          <b-input
            v-model.trim="currentCard.valutations.wholesaler"
            v_uppercase="currentCard.valutations.wholesaler"
            :required="currentCard.products.length > 0"
          ></b-input>
        </b-field>
      </div>
    </div>

    <b-field label="Note">
      <b-input
        v-model.trim="currentCard.valutations.note"
        v_uppercase="currentCard.valutations.note"
        maxlength="600"
        type="textarea"
      ></b-input>
    </b-field>
  </div>
</template>

<script>
export default {
  props: ["currentCard"]
};
</script>
